import { create } from "zustand";
import { authenticatedAxios } from "../../apis";

const useEventStore = create((set, get) => ({
  events: [],
  eventDetail: null,
  markdown: "",
  loadingList: false,
  loadingDetail: false,
  loadingMarkdown: false,
  loadingAction: false,
  error: null,

  actions: {
    fetchIndex: async () => {
      set({ loadingList: true, error: null });
      try {
        const { data } = await authenticatedAxios.get("/api/admin/events/");
        set({ events: Array.isArray(data) ? data : data?.results || [], loadingList: false });
      } catch (err) {
        console.error(err);
        set({ loadingList: false, error: err?.response?.data || "Failed to load events" });
      }
    },

    fetchDetail: async (slug) => {
      set({ loadingDetail: true, error: null });
      try {
        const { data } = await authenticatedAxios.get(`/api/admin/events/${slug}/`);
        set({ eventDetail: data, loadingDetail: false });
      } catch (err) {
        console.error(err);
        set({ loadingDetail: false, error: err?.response?.data || "Failed to load event detail" });
      }
    },

    fetchMarkdown: async (slug) => {
      set({ loadingMarkdown: true, error: null });
      try {
        const { data } = await authenticatedAxios.get(`/api/admin/events/${slug}/markdown`);
        // support both {markdown:"..."} or plain string
        set({ markdown: data?.markdown ?? data ?? "", loadingMarkdown: false });
      } catch (err) {
        console.error(err);
        set({ loadingMarkdown: false, error: err?.response?.data || "Failed to load markdown" });
      }
    },

    createEvent: async (formData) => {
      set({ loadingAction: true, error: null });
      try {
        const { data } = await authenticatedAxios.post("/api/admin/event-upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        set({ loadingAction: false });
        return !!(data?.success ?? true);
      } catch (err) {
        console.error(err);
        set({ loadingAction: false, error: err?.response?.data || "Failed to create event" });
        return false;
      }
    },

    updateEvent: async (slug, formData) => {
      set({ loadingAction: true, error: null });
      try {
        const { data } = await authenticatedAxios.post(`/api/admin/edit-event/${slug}/`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        set({ loadingAction: false });
        return !!(data?.success ?? true);
      } catch (err) {
        console.error(err);
        set({ loadingAction: false, error: err?.response?.data || "Failed to update event" });
        return false;
      }
    },

    deleteEvent: async (slug) => {
      set({ loadingAction: true, error: null });
      try {
        const { data } = await authenticatedAxios.delete(`/api/admin/delete-event/${slug}/`);
        set({ loadingAction: false });
        return !!(data?.success ?? true);
      } catch (err) {
        console.error(err);
        set({ loadingAction: false, error: err?.response?.data || "Failed to delete event" });
        return false;
      }
    },
  },
}));

export default useEventStore;
